import React from "react";
import { Languages, Car, PlaneTakeoff, Clock } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { WHY_US, IMAGES } from "../mock";
import SectionHeader from "./SectionHeader";
import useReveal from "../hooks/useReveal";

const ICONS = { Languages, Car, PlaneTakeoff, Clock };

export default function WhyUs() {
  const { t, S } = useLang();
  const ref = useReveal();

  return (
    <section ref={ref} className="relative py-20 md:py-28 overflow-hidden">
      <img src={IMAGES.hotelXcaret} alt="" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-[#042f37]/85" />

      <div className="relative z-10 max-w-7xl mx-auto px-5 md:px-8">
        <SectionHeader kicker={t(S.whyus.kicker)} title={t(S.whyus.title)} light />

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {WHY_US.map((w, i) => {
            const Icon = ICONS[w.icon];
            return (
              <div
                key={w.title.en}
                className="reveal rounded-2xl bg-white/10 backdrop-blur border border-white/15 p-7 hover:bg-white/15 transition-colors"
                style={{ transitionDelay: `${i * 80}ms` }}
              >
                <span className="grid place-items-center w-14 h-14 rounded-xl bg-accent text-accent-foreground mb-5">
                  <Icon className="w-7 h-7" />
                </span>
                <h3 className="font-display font-bold text-lg text-white">{t(w.title)}</h3>
                <p className="mt-2 text-white/75 text-sm leading-relaxed">{t(w.desc)}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
